module.exports = __webpack_public_path__ + "img/geoffrey-pro.f2643511.jpg";